import { BankerRepoImpl } from "domain/repository/Banker/BankerRepoImpl";
import { ExchangeRateRepoImpl } from "domain/repository/ExchangeRate/ExchangeRateRepoImpl";
import { useBankerTracked } from "presentation/store/Banker/BankerProvider";
import { BankerVM } from "presentation/viewModel/Banker/BankerVM";
import { useMemo } from "react";

export const useBankerVM = () => {
    const [, setBankerState] = useBankerTracked();
    const bankerVM = useMemo(() =>
        BankerVM({
            dispatch: [setBankerState],
            repo: BankerRepoImpl(),
            exchangeRateRepo: ExchangeRateRepoImpl(),
        }), [setBankerState])

    return bankerVM
}